import React from 'react';
import { typeByKey, fmtDate } from '../constants';

// Shared quiet row for a creator item.
export default function ItemRow({ item, t, locale, onOpen, onToggleDone }) {
  const type = typeByKey(item.type);
  const done = item.status === 'done';
  return (
    <div
      className={`crs-row${done ? ' is-done' : ''}${item.type === 'idea' ? ' is-idea' : ''}`}
      data-testid={`creator-item-${item.id}`}
      onClick={() => onOpen?.(item)}
      role="button"
      tabIndex={0}
    >
      {item.type === 'task' ? (
        <button
          type="button"
          className={`crs-row__check${done ? ' is-on' : ''}`}
          data-testid={`creator-item-check-${item.id}`}
          onClick={(e) => { e.stopPropagation(); onToggleDone?.(item); }}
          aria-label={done ? (t.cr_reopen || 'Reopen') : (t.cr_mark_done || 'Mark done')}
        />
      ) : (
        <span className="crs-row__mark" style={{ color: type?.color || '#b5ac9e' }}>
          {type ? React.createElement(type.icon, { size: 13, strokeWidth: 1.6 }) : '\u00b7'}
        </span>
      )}
      <span className="crs-row__title">{item.title}</span>
      {item.type && (
        <em className="crs-row__type" style={{ color: type?.color }}>
          {t[type?.labelKey] || item.type}
        </em>
      )}
      {item.due_date && (
        <span className="crs-row__due">{fmtDate(item.due_date, locale)}</span>
      )}
    </div>
  );
}
